export default {
  container: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
  },
  jobProfiles: {
    flex: 1,
  },
  jobProfileStages: {
    flex: 1,
  },
  stageIcon: {
    // tintColor: 'white',
  },
};



// WEBPACK FOOTER //
// ./src/components/JobProfileDrilldown/styles.js